import React, { useContext, useMemo } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import UnauthorizedPage from '@@/products/portal/pages/unauthorized-access-page';
import { GlobalAuthContext } from '@@/contexts/AuthContext';
import { Box, Spinner } from '@cloudscape-design/components';
import { determineUserPermissions } from '@@/lib/permissions';
import notificationsPermissionMapping, {
  NotificationsPermission
} from '@@/modules/admin/notifications/common/permission-mapping';

const NotificationsAuthorizer = () => {
  const context = useContext(GlobalAuthContext);
  const { pathname } = useLocation();

  const permissions = useMemo(() => {
    if (!context?.globalPermissions) return new Set<NotificationsPermission>();
    const effectivePath = `/portal/cxcentral${pathname}`;
    return determineUserPermissions<NotificationsPermission>(
      context.globalPermissions,
      effectivePath,
      notificationsPermissionMapping
    );
  }, [context?.globalPermissions, pathname]);

  if (!context || context.loading) {
    return (
      <Box padding='xxl' textAlign='center'>
        <Spinner size='large' />
      </Box>
    );
  }

  if (context.error) {
    return <div aria-label={'API Error'}>API Error: {context.error.toString()}</div>;
  }

  if (!permissions || permissions.size === 0) {
    return <UnauthorizedPage />;
  }

  return <Outlet context={{ permissions }} />;
};

export default NotificationsAuthorizer;
